<template>
  <v-ons-list-item
    modifier="longdivider"
    @click="showDetail"
  >
    <div class="left">
      <img
        :src="image"
        width="102px"
      >
    </div>
    <div class="center">
      <section class="destination-outline">
        <p>サイネージでは<br>こちらの情報の閲覧はできません</p>
      </section>
    </div>
  </v-ons-list-item>
</template>

<script>
const userNoImage = require('@/assets/images/user-noimage.svg');

export default {
  props: {
    thing: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isFloorIdExisted: ({ thing }) => thing.thingPositions != null && thing.thingPositions[0].length > 0,
    floorId: ({ thing, isFloorIdExisted }) => (isFloorIdExisted ? thing.thingPositions[0].floor.id : null),
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    image: () => userNoImage,
  },
  methods: {
    showDetail() {
      // NOTE: 詳細画面では遷移させない
      if (!this.$el.hasAttribute('tappable')) return;

      // NOTE: 別の建物にある場合は移動する
      if (this.isFloorIdExisted && this.currentFloorId !== this.floorId) this.$store.commit('current/setFloorId', this.floorId);

      this.$store.commit('current/setDestination', this.thing);
      this.$store.dispatch('searchResult/getThing', this.thing.id);
      this.$store.dispatch('destinationDetail/show');
    },
  },
};
</script>



// WEBPACK FOOTER //
// person.vue?44e69534